import { ref } from "vue";
import { Pool } from "@/models/pool.model";
import { useRouter } from "vue-router";

export const lastPool = ref<Pool | null>(null);

export const useGoToLastPool = () => {
  const router = useRouter();
  return () => {
    if (lastPool.value) {
      router.push(`/pool/${lastPool.value.idSystem}`);
    }
  };
};
